import { useClerk } from '@clerk/clerk-react';
import { useCallback } from 'react';

// Set while a sign-out the user asked for is in flight. InnerApp hard-reloads
// when Clerk unexpectedly drops a session (idle tab / sleep); this flag tells it
// the drop is deliberate so Clerk's own redirect to /login goes through untouched.
let intentionalSignOutInProgress = false;

export function isIntentionalSignOutInProgress(): boolean {
  return intentionalSignOutInProgress;
}

/** Signs the user out on purpose (menu "Sign out" buttons), then goes to `redirectUrl`. */
export function useIntentionalSignOut() {
  const { signOut } = useClerk();

  return useCallback(
    async (redirectUrl: string = '/login') => {
      intentionalSignOutInProgress = true;
      try {
        await signOut({ redirectUrl });
      } catch (err) {
        intentionalSignOutInProgress = false;
        throw err;
      }
    },
    [signOut]
  );
}
